import StatusHandler from 'app/shared-components/StatusHandler'

import useGetContractBasis from '../hooks/useGetContractBasis'
import ContractBasisDetails from './ContractBasisDetails'

type Props = {
    id?: number,
}

export default function ContractBasisDetailsContainer({
    id,
}: Readonly<Props>) {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetContractBasis(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ContractBasisDetails
                onSuccess={invalidate}
                data={data}
            />
        </StatusHandler>
    )
}
